<template>
  <div>
    <b-form @submit.prevent="updateGeoPoint" @mouseover="geoPoint.extraData.grow = 5" @mouseout="geoPoint.extraData.grow = 0">
      <b-form-row>
        <b-form-group class="col-12">
          <label :for="'geopoint-name-' + index" v-translate>Name <small class="text-danger">(required)</small></label>
          <b-form-input :id="'geopoint-name-' + index" v-model="geoPoint.name" type="text" required />
        </b-form-group>
        <b-form-group class="col-12">
          <label :for="'geopoint-type-' + index" v-translate>Type <small class="text-danger">(required)</small></label>
          <b-form-select :id="'geopoint-type-' + index" v-model="geoPoint.geo_type_id" :options="geoTypesSelect.filter(x => x.type === geoPoint.point.type.toLowerCase())" v-if="geoTypesSelect.length > 0" required>
            <template #first>
              <option :value="null">Select the Type</option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-form-row>
      <b-button size="sm" :variant="geoPointHasChanges ? 'secondary' : 'dark'" :disabled="!geoPointHasChanges" type="submit">
        <b-spinner small v-if="updating"></b-spinner>
        <translate>Save Changes</translate>
      </b-button>
      <b-button size="sm" @click.prevent="emitCenter" :title="$gettext('Center in Map')" v-b-tooltip.hover><font-awesome-icon icon="crosshairs" /></b-button>
      <b-button size="sm" variant="dark" @click="geoPoint.extraData.visible = !geoPoint.extraData.visible" :title="!geoPoint.extraData.visible ? $gettext('Show Element') : $gettext('Hide Element')" v-b-tooltip.hover>
        <font-awesome-icon :icon="['far', 'eye']" v-show="!geoPoint.extraData.visible" />
        <font-awesome-icon :icon="['far', 'eye-slash']" v-show="geoPoint.extraData.visible" />
      </b-button>
      <b-button size="sm" variant="danger" @click="removeGeoPoint" :title="$gettext('Remove Relation')" v-b-tooltip.hover>
        <font-awesome-icon icon="unlink" />
      </b-button>
    </b-form>
  </div>
</template>

<script>
import {
  GeofenceService,
  GeoPointService
} from '@/services/api'

export default {
  emits: ['center', 'remove', 'updated'],
  name: 'GeoPointForm',
  props: {
    geoPoint: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      default: Math.random()
    }
  },
  data() {
    return {
      geoTypesSelect: [],
      hash: null,
      updating: false
    }
  },
  computed: {
    geoPointHasChanges() {
      const geoPointHash = { ...this.geoPoint }
      delete geoPointHash.extraData
      return JSON.stringify(geoPointHash) !== this.hash
    }
  },
  watch: {
    'geoPoint.geo_type_id': {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue) {
          this.geoPoint.geo_type = this.geoTypes.find(x => x.id === newValue)
        } else {
          this.geoPoint.geo_type = {
            name: ''
          }
        }
      }
    }
  },
  created () {
    this.geoTypesSelect = this.geoTypes.map(x => {
      return {
        text: this.toTitleCase(x.name),
        value: x.id,
        type: x.type
      }
    })
  },
  mounted () {
    const geoPointHash = { ...this.geoPoint }
    delete geoPointHash.extraData
    this.hash = JSON.stringify({ ...geoPointHash })
    if (this.geoPoint.id && this.geoPoint.adding) {
      GeofenceService.addGeopoint(this.geoPoint.parent, this.geoPoint.id)
        .then(() => {
          this.$nextTick(() => {
            this.$emit('updated', true)
            const geoPointHash = { ...this.geoPoint }
            delete geoPointHash.extraData
            this.hash = JSON.stringify({ ...geoPointHash })
          })
        })
    }
  },
  methods: {
    updateGeoPoint() {
      this.updating = true
      if (this.geoPoint.id) {
        GeoPointService.update(this.geoPoint.id, this.geoPoint)
          .then(() => {
            this.$nextTick(() => {
              this.$emit('updated', true)
              this.updating = false
            })
          })
      } else {
        GeoPointService.create(this.geoPoint)
          .then(response => {
            GeofenceService.addGeopoint(this.geoPoint.parent, response.body.id)
              .then(() => {
                this.$nextTick(() => {
                  this.$emit('updated', true)
                  this.updating = false
                })
              })
          })
      }
    },
    removeGeoPoint() {
      if (confirm(this.$gettext('Are you sure you want to REMOVE THIS RELATION?'))) {
        if (this.geoPoint.id) {
          GeofenceService.removeGeopoint(this.geoPoint.parent, this.geoPoint.id)
            .then(() => {
              this.$nextTick(() => {
                this.$emit('updated', true)
              })
            })
        } else {
          this.$emit('remove', true)
        }
      }
    },
    emitCenter($event) {
      this.$emit('center', 'point', [this.geoPoint.lat, this.geoPoint.lng])
    }
  }
}
</script>
